import ToolbarButton from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarButton';

const Underline = () => (
  <ToolbarButton
    className="ql-underline"
    text={__('Underline')}
    iconName="underline"
    dataTestId="toolbar-underline"
  />
);

export default Underline;
